export function ScoreBoard({ score }) {
  return <h3 className="scoreboard">Score: {score}</h3>;
}
